import script from "./SimpleReviewSummary.vue?vue&type=script&setup=true&lang=ts"
export * from "./SimpleReviewSummary.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__